import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuidedTourOverlayComponent } from './guided-tour-overlay/guided-tour-overlay.component';
import { TutorialHintComponent } from './tutorial-hint/tutorial-hint.component';

/**
 * Módulo del sistema de tutoriales guiados (SCG-368, portado de OSINT).
 * Declara y exporta el overlay del coach-mark, que se monta UNA vez alto en el
 * árbol (app.component.html) para flotar sobre cualquier módulo, y el chip
 * `app-tutorial-hint`. El motor (`GuidedTourService`) y la persistencia
 * (`TutorialProgressService`) son `providedIn: 'root'`.
 */
@NgModule({
  declarations: [GuidedTourOverlayComponent, TutorialHintComponent],
  imports: [CommonModule],
  exports: [GuidedTourOverlayComponent, TutorialHintComponent],
})
export class GuidedTourModule {}
